module.exports = __webpack_public_path__ + "images/buttons/import_contacts-gray.gif";